/**
 * MEERHOO — mobile header: nav drawer + search (single controller; avoids theme Drawers double-toggle)
 */
(function () {
  var OPEN = 'js-drawer-open';
  var OPEN_LEFT = 'js-drawer-open-left';

  function drawerApi() {
    return typeof theme !== 'undefined' && theme.NavDrawer ? theme.NavDrawer : null;
  }

  function isOpen() {
    var api = drawerApi();
    if (api && typeof api.drawerIsOpen === 'boolean') return api.drawerIsOpen;
    return document.body.classList.contains(OPEN_LEFT);
  }

  function setBodyOpen(open) {
    [document.documentElement, document.body].forEach(function (root) {
      root.classList.toggle(OPEN, open);
      root.classList.toggle(OPEN_LEFT, open);
    });
  }

  function setToggleExpanded(open) {
    document.querySelectorAll('.mh-menu-toggle').forEach(function (btn) {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function openDrawer() {
    var api = drawerApi();
    if (api && typeof api.open === 'function') {
      api.open();
    } else {
      setBodyOpen(true);
    }
    setToggleExpanded(true);
  }

  function closeDrawer() {
    var api = drawerApi();
    if (api && typeof api.close === 'function') {
      api.close();
    } else {
      setBodyOpen(false);
    }
    setToggleExpanded(false);
  }

  function toggleDrawer(evt) {
    if (evt) {
      evt.preventDefault();
      evt.stopPropagation();
    }
    if (isOpen()) closeDrawer();
    else openDrawer();
  }

  function detachThemeDrawerToggle() {
    var api = drawerApi();
    if (!api || !api.config || !window.jQuery) return;
    window.jQuery(api.config.open).off('click');
  }

  function bindMenu() {
    document.querySelectorAll('.mh-menu-toggle').forEach(function (btn) {
      if (btn.dataset.mhMenuBound === '1') return;
      btn.dataset.mhMenuBound = '1';
      btn.addEventListener('click', toggleDrawer);
    });

    var drawer = document.getElementById('NavDrawer');
    if (!drawer) return;

    if (drawer.dataset.mhMenuCloseBound !== '1') {
      drawer.dataset.mhMenuCloseBound = '1';
      drawer.querySelectorAll('.js-drawer-close, .js-drawer-close .close').forEach(function (el) {
        el.addEventListener('click', function (e) {
          e.preventDefault();
          closeDrawer();
        });
      });

      drawer.querySelectorAll('.mh-premium-nav a[href], .drawer__nav-sublist a[href]').forEach(function (link) {
        link.addEventListener('click', function () {
          closeDrawer();
        });
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) closeDrawer();
    });
  }

  function bindSearch() {
    var searchMobile = document.querySelector('.modal__toggle-search-mobile');
    var detailModal = document.querySelector('.site-header__search-wrap:not(.sidebar__search) .detail-modal');
    var overlayOpen = document.querySelector('.site-header__search-wrap:not(.sidebar__search) .modal-overlay');
    var closeBtn = document.querySelector('.search-modal__close-button');
    var desktopOpen = document.querySelector('.site-header__search-wrap .modal__toggle-open');

    if (!detailModal || !overlayOpen) return;

    function toggleSearch(evt) {
      if (evt) {
        evt.preventDefault();
        evt.stopPropagation();
      }
      if (isOpen()) closeDrawer();
      detailModal.classList.toggle('active');
      overlayOpen.classList.toggle('active');
      var input = document.getElementById('Search-In-Modal');
      if (input && detailModal.classList.contains('active') && window.matchMedia('(min-width: 992px)').matches) {
        input.focus();
      }
    }

    function closeSearch() {
      detailModal.classList.remove('active');
      overlayOpen.classList.remove('active');
      var input = document.getElementById('Search-In-Modal');
      if (input) input.value = '';
      var pred = document.querySelector('.predictive-search');
      if (pred) pred.style.display = 'none';
    }

    [searchMobile, desktopOpen].forEach(function (el) {
      if (!el || el.dataset.mhSearchBound === '1') return;
      el.dataset.mhSearchBound = '1';
      el.addEventListener('click', toggleSearch);
    });

    if (overlayOpen.dataset.mhSearchBound !== '1') {
      overlayOpen.dataset.mhSearchBound = '1';
      overlayOpen.addEventListener('click', closeSearch);
    }

    if (closeBtn && closeBtn.dataset.mhSearchBound !== '1') {
      closeBtn.dataset.mhSearchBound = '1';
      closeBtn.addEventListener('click', closeSearch);
    }
  }

  function ensureThemeDrawer() {
    if (typeof theme === 'undefined' || typeof theme.Drawers !== 'function') return;
    if (theme.NavDrawer && theme.NavDrawer.$drawer && theme.NavDrawer.$drawer.length) return;
    if (!document.getElementById('NavDrawer')) return;
    theme.NavDrawer = new theme.Drawers('NavDrawer', 'left', { open: '.js-mh-drawer-open-placeholder' });
  }

  function init() {
    ensureThemeDrawer();
    detachThemeDrawerToggle();
    bindMenu();
    bindSearch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
